import React from "react";
import { twMerge } from "tailwind-merge";
import { ITextInputErrorWarning } from "../../../store/@types/misc";

type ITextBox = {
  label: string;
  labelClassName?: string;
  name: string;
  value: string;
  type?: "text";
  placeholder: string;
  required?: boolean;
  status: ITextInputErrorWarning;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  icon?: React.ReactNode;
  loading?: boolean;
  className?: string;
  rowsValue?: number;
};

const TextBox: React.FC<ITextBox> = ({
  label,
  labelClassName,
  name,
  value,
  placeholder,
  required,
  status,
  icon,
  className,
  onChange,
  rowsValue,
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const borderColor = status ? "border-[red]" : "border-[#e5e7eb]";
  return (
    <div className="w-full">
      <label className={twMerge("font-medium", labelClassName)}>{label}</label>
      <div
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={`flex w-full border items-center outline-none mt-1 text-gray-900 px-3 py-2 focus:shadow-sm bg-[white] focus-within:ring focus-within:ring-primary-100/30 rounded-lg ${
          isFocused ? "border-primary-500" : borderColor
        }`}
      >
        {icon && <div className="mr-1 border-r pr-2">{icon}</div>}
        <textarea
          value={value}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          rows={rowsValue}
          className={twMerge(
            "w-full !outline-none px-0 py-0 placeholder:text-gray-400 border-none focus:border-transparent  focus:ring-0",
            className
          )}
        ></textarea>
      </div>
    </div>
  );
};

export default TextBox;
